module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', [_vm._v("I Love Ramen")]), _vm._v(" "), _c('div', {
    staticClass: "toc"
  }, [_c('p', [_c('b', [_vm._v("Table of Contents")])]), _vm._v(" "), _c('dl', [_c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Introduction ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Soups & Salads")])])]), _vm._v(" "), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02#d0e153",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Slow Chicken Soup ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02#d0e186",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Curried Chicken Soup ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02#d0e218",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ham & Black-Eyed Peas ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02#d0e246",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spicy Shrimp & Noodle Soup ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02#d0e285",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("South of the Border Ramen Soup ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02#d0e326",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Miso & Veggie Ramen Soup ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02#d0e362",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chunky Noodle Salad ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02#d0e396",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tossed Mandarin Salad ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02#d0e440",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Crunchy Fruit Salad ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02#d0e460",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Antipasto Salad ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02#d0e480",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nutty Broccoli Slaw ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02#d0e515",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Taco Salad ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02#d0e537",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Quick Chicken Salad ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02#d0e567",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oriental Chicken Salad ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02#d0e599",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tofu & Cabbage Toss ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02#d0e645",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tangerine Chicken Salad ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02#d0e690",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chicken Fajita Ramen Salad ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02#d0e731",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Three Sprout Salad ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02#d0e778",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Polish Ramen Salad ")])])])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beef & Pork Mains")])])]), _vm._v(" "), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e808",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ramen Rolled Steak ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e841",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Yatsobi ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e884",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Slow Cooker Beef & Noodles ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e904",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beef Ramenoff ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e934",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stuffed Bell Peppers ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e975",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Creamy Beef & Broccoli Noodles ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e1003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beef Provençale")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e1035",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cheddar Beef Casserole ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e1067",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beefy Mushroom Noodles ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e1095",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beef & Broccoli Stir-Fry ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e1126",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beef Sukiyaki ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e1162",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beef & Chestnut Casserole ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e1192",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Beefy Chili Noodles ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e1223",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cheeseburger Ramen")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e1243",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oriental Hot Dogs ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e1267",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cheesy Bacon Noodles ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e1290",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pork Chops & Ramen ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e1314",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hungarian Goulash à la Ramen ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e1338",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Saucy Chops & Peppers ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e1379",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tropical Ramen ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e1406",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Broccoli, Mushroom & Ham Casserole\n                                ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e1442",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spicy Sausage Ramen ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e1468",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gingered Pork & Snow Peas ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e1503",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Breakfast Ramen ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e1539",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bacon-Fried Ramen ")])])])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chicken & Turkey Mains")])])]), _vm._v(" "), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e1571",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chicken Broccoli Bake ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e1616",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cheesy Chicken Divan ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e1650",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Herbed Chicken ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e1680",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hot & Sour Ramen ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e1717",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cheesy Chicken Casserole ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e1745",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chicken ’n’ Asparagus ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e1767",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Honey Grilled Chicken ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e1818",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chicken Alfredo ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e1848",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thai Chicken ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e1870",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fiesta Chicken ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e1903",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chicken Lo Mein ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e1929",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chilled Caesar Chicken ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e1951",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Turkey Pasta Pie ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e1998",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pesto Turkey & Pasta ")])])])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Seafood Mains")])])]), _vm._v(" "), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e2024",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Garlic Shrimp ’n’ Veggies ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e2055",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Salmon Simmer ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e2081",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cajun Shrimp & Chicken Gumbo ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e2109",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Crab Lo Mein ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e2148",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Coconut Curry Shrimp ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e2183",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tuna Noodle Casserole ")])])])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Veggie Mains & Sides")])])]), _vm._v(" "), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e2213",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spinach Parmesan Ramen ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e2248",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cheesy Vegetable Ramen ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e2268",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pan-Fried Noodles ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e2290",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Asian Noodle Toss ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e2321",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grilled Ramen ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e2345",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Frittatas ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e2373",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stuffed Tomatoes ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e2414",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pizza Pasta ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e2440",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cheesy Ranch Ramen ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e2456",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Primavera Pasta ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e2491",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Buttery Chive Noodles ")])])])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sweet on Ramen")])])]), _vm._v(" "), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e2513",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Trail Mix ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e2547",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Maple & Brown Sugar Ramenmeal ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e2569",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Caramel Crisps ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e2593",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thin Mint on a Stick ")])])])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Metric Conversion Chart")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59b4cf77","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bk01-toc.vue
// module id = 63
// module chunks = 0